import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { colors } from "@ippon/shared-components";
import { SparklesIcon } from "@ippon/shared-assets";

interface Props {
  fileName: string;
}

/**
 * OCR 処理中画面 (upload → processing → form の真ん中)。
 */
const ExpenseOcrProcessingStep: React.FC<Props> = ({ fileName }) => {
  return (
    <Box>
      <Stack
        alignItems="center"
        spacing={2}
        sx={{
          py: 6,
          px: 2,
        }}
      >
        <Box sx={{ position: "relative" }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: "50%",
              backgroundColor: colors.background.selected,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: 28,
                height: 28,
                color: colors.primary.main,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                animation: "ai-pulse 1.6s ease-in-out infinite",
                "@keyframes ai-pulse": {
                  "0%, 100%": { opacity: 0.6 },
                  "50%": { opacity: 1 },
                },
                "& svg": { width: 28, height: 28 },
              }}
            >
              <SparklesIcon />
            </Box>
          </Box>
          {/* 右下に被せる小スピナーバッジ */}
          <Box
            sx={{
              position: "absolute",
              bottom: -4,
              right: -4,
              width: 24,
              height: 24,
              borderRadius: "50%",
              backgroundColor: "#FFFFFF",
              border: `2px solid ${colors.primary.main}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                width: 12,
                height: 12,
                borderRadius: "50%",
                border: "2px solid",
                borderColor: colors.primary.main,
                borderTopColor: "transparent",
                animation: "ocr-spin 0.8s linear infinite",
                "@keyframes ocr-spin": {
                  to: { transform: "rotate(360deg)" },
                },
              }}
            />
          </Box>
        </Box>
        <Typography
          sx={{
            fontSize: 16,
            fontWeight: 700,
            color: colors.text.primary,
          }}
        >
          AI が読み取り中...
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            color: colors.text.secondary,
            wordBreak: "break-all",
            textAlign: "center",
          }}
        >
          {fileName}
        </Typography>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ mt: 2, color: colors.text.secondary }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 16, color: colors.status.success }}
          />
          <Typography sx={{ fontSize: 12 }}>文書を解析中</Typography>
        </Stack>
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{ color: colors.text.secondary }}
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              border: "2px solid",
              borderColor: colors.primary.main,
              borderTopColor: "transparent",
              animation: "ocr-spin 0.8s linear infinite",
            }}
          />
          <Typography sx={{ fontSize: 12 }}>データを抽出中</Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ExpenseOcrProcessingStep;
